import {
    all, call, put, takeLatest
} from 'redux-saga/effects';
import { defaultSaga, getActions } from '../utils';

import * as constants from './constants';
import * as api from './api';
import converter from './converter';
import { updateCalculate } from '../item-calculate/actions';

function* addRBSaga({ payload }) {
    const [start, success, failure] = getActions(
        constants.addRB.try,
        constants.addRB.success,
        constants.addRB.error
    );
    try {
        const { calculate, values } = payload;
        yield put(start());
        const dataRaw = yield call(api.addRB, values);
        const data = converter.toClient(dataRaw);
        yield put(updateCalculate({ id: calculate.id, values: { rb: data.id, ...calculate } }));
        yield put(success(data));
    } catch (error) {
        yield put(failure(error));
    }
}

export default function* rootSaga() {
    yield all([
        yield takeLatest(
            constants.getRB.toString(),
            defaultSaga({
                constants: constants.getRB,
                api: api.getRB,
                after: converter.toClient
            })
        ),
        yield takeLatest(
            constants.getRBs.toString(),
            defaultSaga({
                constants: constants.getRBs,
                api: api.getRBs
            })
        ),
        yield takeLatest(
            constants.addRB.toString(),
            addRBSaga
        ),
        yield takeLatest(
            constants.updateRB.toString(),
            defaultSaga({
                constants: constants.updateRB,
                api: api.updateRB,
                after: converter.toClient
            })
        )
    ]);
}